export function getDeviceModel() {
    var userAgent = navigator.userAgent;
    var isMobile = /mobile/i.test(userAgent);
    var isTablet = /tablet|ipad|playbook|silk/i.test(userAgent);
    return isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
}